<template>
      <b-nav-item-dropdown text="Editorial Board">
        <b-dropdown-item @click="goTo({ name: 'editorialBoardMembers' })">Editorial Board Members</b-dropdown-item>
        <b-dropdown-item @click="goTo({ name: 'hundredPlus' })">100+ Papers from Editorial Board</b-dropdown-item>
      </b-nav-item-dropdown>
</template>

<script>
  export default {
    name: 'editorial-board-dropdown',
    methods: {
      goTo (rO) {
        this.$router.push(rO)
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// EditorialBoardDropdownComponent.vue?6dffd5b4